<template>
  <section class="section" id="transactions-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <clients-title
        @update-days="updateDays"
        @update-store="updateStore"
        @get-clients="getClients"
      />

      <h2 v-if="clients.length === 0" class="subtitle has-text-centered">
        {{ $t("clients.noClientssAtThisTime") }}
      </h2>

      <div v-else>
        <clients-table :clients="clients" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import clientsTitle from "./ClientsTitle";
import clientsTable from "./clients-table/ClientsTable";

export default {
  mixins: [common, mask],

  components: {
    clientsTitle,
    clientsTable
    // transactionsTable
  },

  data() {
    return {
      isLoading: false,
      days: "90",
      store: undefined,
      storeName: null,
      clients: []
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "transactionsReverse", "permissions"]),

    approvedTransactions() {
      return this.transactionsReverse.filter(t => {
        return t.details.status === "success";
      }).length;
    }
  },

  methods: {
    getClients() {
      const data = {
        storeId: this.store,
        days: this.days
      };

      this.isLoading = true;
      this.$store
        .dispatch("getClients", data)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            console.log("Resposta: ", res.data.payload);
            this.clients = res.data.payload.clients;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateDays(days) {
      this.days = days;
    },

    updateStore(store) {
      this.store = store ? store.split("|")[0] : "";
      this.storeName = store
        ? store.split("|")[1]
        : this.$t("transactions.allStores");
    }
  },

  mounted() {
    // this.getTransactions();
  }
};
</script>

<style scoped>
#transactions-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
